require('/var/www/vhosts/partybox.pl/httpdocs/edytor/app/assets/shared.js')